import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';

const TypicalProductImageSlider = ({ photo, photoAlt }) => {
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        if (photo) {
            const image = new Image();
            image.src = photo;
            image.onload = () => {
                setHasError(false);
            };
            image.onerror = () => {
                setHasError(true);
            };
        } else {
            setHasError(true);
        }
    }, [photo]);
      



    return (
        <div>
        <a className="room-tile" href="javascript:;">
            <span className="room-tile-inner">
                <span className="room-tile-image-wrap">
                    {hasError ? (
                        <span className="errorImage">Image Coming Soon</span>
                    ) : (
                        <img src={photo} alt={photoAlt} />
                    )}
                </span>
            </span>
        </a>
        </div>


    );
};

TypicalProductImageSlider.propTypes = {
    photo: PropTypes.string,
    photoAlt: PropTypes.string,
    styles: PropTypes.string
};

export default TypicalProductImageSlider;